import { render, staticRenderFns } from "./AdminPropertyView.vue?vue&type=template&id=3822861d&scoped=true"
import script from "./AdminPropertyView.vue?vue&type=script&lang=ts"
export * from "./AdminPropertyView.vue?vue&type=script&lang=ts"
import style0 from "./AdminPropertyView.vue?vue&type=style&index=0&id=3822861d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3822861d",
  null
  
)

export default component.exports